import { format } from 'date-fns'
import type { LlmChatSessionDto } from '@/shared/hooks/api/llmChat'

export function llmChatSessionTitle(
  session: LlmChatSessionDto,
  untitled: string
): string {
  const title = session.title?.trim()
  if (title && title.length > 0) {
    return title
  }

  const summary = session.summaryText?.trim()
  if (summary) {
    const line = summary.split('\n')[0]?.trim() ?? ''
    if (line.length > 0) {
      return line
    }
  }

  return untitled
}

export function llmChatSessionListLabel(
  session: LlmChatSessionDto,
  untitled: string
): { primary: string; secondary: string } {
  const title = llmChatSessionTitle(session, untitled)
  const primary = title.length > 52 ? `${title.slice(0, 49)}…` : title

  return {
    primary,
    secondary: format(new Date(session.updatedAt), 'd MMM yyyy, HH:mm'),
  }
}
